<!--
일괄기능 컨트롤러에 사용되는
    - 일괄실행 대상 아이템의 체크여부를 컨트롤해주는 기능의 mixin
------------------------------------

-->

<script>
    import { get_region } from '../../../classes/region-factory';

    export default {
        props: {
            //
            /**
             * 일괄기능에 대한 공유data
             * ---------------------------
             * {
             *  // 일괄실행의 대상이되는 아이템 배열
             *  items: [
             *      {
             *          id: (필수) int, 아이템의 고유id
             *          checked: (필수) boolean, 현재 선택되었는지 여부
             *
             *          .
             *          .
             *          <작업-컴포넌트> 에서 필요한 정보들이 있다면 추가적으로 선언하면 됨
             *          예 )
             *          name: '사과',
             *          amount: 1
             *      }
             *  ],
             *  itemCheckedCount: 현재 선택된 아이템 수
             *
             *  title: 컨트롤러 타이틀
             *
             *  item_checked_msg_format: 현재 선택정보 안내메세지 포맷. ':count'가 선택수량으로 치환처리됨
             *  item_checked_nothing_msg: 하나도 선택되지 않았을때의 메세지
             *
             */
            batch: Object,

            // 하나도 선택된 아이템이 없을때, 화면에 표시안하도록 설정
            hideNoneChecked: {
                type: Boolean,
                default: false
            },
        },
        computed: {
            /**
             * 선택된 아이템 배열
             * @return array
             */
            checkedItems() {
                // 선택 된 아이템만 필터
                return _.filter(this.batch.items, ['checked', true]);
            },

            /**
             * 아이템 선택여부
             * @return boolean
             */
            itemChecked() {
                return this.checkedItems.length > 0
            },

            /**
             * 아이템 선택 카운트
             * @return int
             */
            itemCheckedCount() {
                // 선택 카운트
                return this.checkedItems.length;
            },

            /**
             * 아이템 선택 정보( 선택개수 안내 메세지 )
             *  - 주어진 메세지 포맷에서 ':count' 에 대한 치환처리가 이루어짐
             * @return string
             */
            itemCheckedInfo() {

                if (this.itemCheckedCount > 0) {
                    // 치환
                    return _.replace(
                        this.batch.item_checked_msg_format,
                        ':count',
                        '<span class="uk-text-primary uk-text-large">'+this.itemCheckedCount+'</span>'
                    );
                }
                return '';
            },

            /**
             * 선택된 아이템의 센터별 카운트
             *  - region_id가 있는 아이템만 집계
             * @return array [{name, flag16, count}, ...]
             */
            checkedRegionCounts() {
                let items = _.filter(this.checkedItems, 'region_id');
                let counts = _.countBy(items, 'region_id');
                return _.compact(_.map(counts, (count, regionId) => {
                    let region = get_region(regionId);
                    if (!region) return null;
                    return { name: region.name, flag16: region.flag16, count: count };
                }));
            }
        },
        watch: {
            // 현재 선택 카운트를 공유data에 설정
            checkedItems: function (arr) {
                this.batch.checked_items = arr;
                this.batch.checked_item_count = arr.length;
            }
        },
    }
</script>